import React, { useEffect, useMemo, useState, useCallback } from 'react';
import business from '../../services/business.js';
import InputForm from "../Form/InputForm.js";
import Loading from '../Loading.js';
import Modal from '../Modal';
import config from '../../config/config.js';
import { toast as alert } from "react-toastify";

const toOption = (item) => ({ value: item.id, label: item.nome || item.desc || `#${item.id}` });

export default function ModalTrocaEtapa({ hideModal, show, processo = {}, onAtualizado }) {
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false);

    const [defaultEtapas, setDefaultEtapas] = useState([]);
    const [defaultStatus, setDefaultStatus] = useState([]);

    const [statusLoading, setStatusLoading] = useState(false);

    const [filtros, setFiltros] = useState({ etapa: null, status: null });

    const tipoProcesso = useMemo(
        () => processo?.id_processo_tipo,
        [processo]
    );

    const setModel = (_name, value) => {
        setFiltros((prev) => ({
            ...prev,
            [_name]: value || null,
            ...(_name === 'etapa' ? { status: null } : {}),
        }));
    };

    const carregarEtapas = useCallback(async () => {
        if (!tipoProcesso) return [];
        const lista = await business.getAdmEtapa(tipoProcesso);
        const opts = (Array.isArray(lista) ? lista : []).map(toOption);
        setDefaultEtapas(opts);
        return opts;
    }, [tipoProcesso]);

    const carregarStatus = useCallback(async (idEtapa) => {
        if (!tipoProcesso || !idEtapa) {
            setDefaultStatus([]);
            return [];
        }
        setStatusLoading(true);
        try {
            const lista = await business.getAdmStatus(tipoProcesso, idEtapa);
            const opts = (Array.isArray(lista) ? lista : []).map(toOption);
            setDefaultStatus(opts);
            return opts;
        } finally {
            setStatusLoading(false);
        }
    }, [tipoProcesso]);

    const loadOptionsEtapa = async () => carregarEtapas();
    const loadOptionsStatus = async () => carregarStatus(filtros?.etapa?.value);

    useEffect(() => {
        const init = async () => {
            if (!processo?.id) return;
            if (!config.isAdmin()) setDisable(true);

            setLoading(true);
            try {
                const etapas = await carregarEtapas();

                const etapaAtualId = processo?.id_etapa || processo?.etapa?.id;
                const statusAtualId = processo?.id_status || processo?.status?.id;

                let etapaSelecionada = null;
                if (etapaAtualId) etapaSelecionada = etapas.find(e => e.value === etapaAtualId) || null;

                let statusSelecionado = null;
                if (etapaSelecionada?.value) {
                    const sts = await carregarStatus(etapaSelecionada.value);
                    if (statusAtualId) statusSelecionado = sts.find(s => s.value === statusAtualId) || null;
                } else {
                    setDefaultStatus([]);
                }

                setFiltros({ etapa: etapaSelecionada, status: statusSelecionado });
            } catch (err) {
                console.error('Falha ao inicializar etapas/status:', err);
                alert.error('Não foi possível carregar Etapas/Status.');
            } finally {
                setLoading(false);
            }
        };

        init();
    }, [processo, carregarEtapas, carregarStatus]);

    useEffect(() => {
        const atualizar = async () => {
            if (filtros?.etapa?.value) {
                await carregarStatus(filtros.etapa.value);
            } else {
                setDefaultStatus([]);
            }
        };
        atualizar();
    }, [filtros?.etapa?.value, carregarStatus]);

    const salvar = async (e) => {
        const body = document.body;
        try {
            const idProcesso = processo?.id;
            const idEtapa = filtros?.etapa?.value;
            const idStatus = filtros?.status?.value;

            if (!idProcesso || !idEtapa || !idStatus) {
                alert.warn('Selecione uma etapa e um status.');
                return;
            }

            setLoading(true);
            const resp = await business.putEtapaStatus(idProcesso, idEtapa, idStatus);

            if (resp?.status === 200 || resp?.response || resp === true) {
                body.classList.remove('overflow-hidden');
                alert.success('Etapa e status alterados com sucesso.');
                if (typeof onAtualizado === 'function') {
                    await onAtualizado();
                }
                hideModal(e);
            } else {
                alert.error('Não foi possível salvar as alterações.');
            }
        } catch (error) {
            console.error("Erro ao salvar etapa/status:", error);
            alert.error("Não foi possível salvar as alterações. Tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={show}
            handleClose={hideModal}
            style={{ maxWidth: '700px', maxHeight: '800px' }}
            modalClass="modal-cad-usuario"
        >
            <div className="flex">
                <div className="form w-100">
                    <h1 className="title mb-45">Troca de Etapa</h1>

                    {loading ? (
                        <Loading />
                    ) : (
                        <div>
                            <InputForm
                                className="mb-30"
                                name="etapa"
                                value={filtros.etapa}
                                disabled={disable}
                                label="Etapa"
                                type="select-search-async"
                                model={(name, val) => setModel('etapa', val)}
                                optionsAsync={loadOptionsEtapa}
                                defaultOptions={defaultEtapas}
                                placeholder="Escolha uma etapa.."
                                isMulti={false}
                            />

                            <InputForm
                                className="mb-30"
                                name="status"
                                value={filtros.status}
                                disabled={disable || !filtros?.etapa?.value || statusLoading}
                                label="Status"
                                type="select-search-async"
                                model={(name, val) => setModel('status', val)}
                                optionsAsync={loadOptionsStatus}
                                defaultOptions={defaultStatus}
                                placeholder={
                                    !filtros?.etapa?.value
                                        ? 'Selecione uma etapa primeiro'
                                        : statusLoading
                                            ? 'Carregando status...'
                                            : 'Escolha um status..'
                                }
                                isMulti={false}
                            >
                                {statusLoading && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            right: 50,
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            pointerEvents: 'none'
                                        }}
                                    >
                                        <Loading />
                                    </div>
                                )}
                            </InputForm>
                        </div>
                    )}

                    <div className="form-rodape mt-30 ">
                        <button className="btn btn-outline-primary f700-16" onClick={hideModal}>
                            Cancelar
                        </button>
                        <button className="btn btn-primary f700-16" onClick={salvar} disabled={disable || loading || statusLoading}>
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
